import React, { useCallback, useMemo } from 'react';

import { Pressable } from 'react-native';

import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import {
    RootTemplates,
    TEMPLATE_TO_PATHNAME,
    TEMPLATE_TO_SENTRY_NAVIGATION,
    TEMPLATE_TO_SENTRY_RENDERING,
} from 'router/types';

import { MenuConfigurationItem } from 'store/railsBuilder/reducer.types';
import { startSentryTransaction } from 'store/sentry/actions';

import LocalizedText from 'components/LocalizedText';

import styles from '../styles';

type Props = {
    tab: MenuConfigurationItem;
    pathname: string;
    onPress(menuItem: MenuConfigurationItem): void;
};

function MainMenuItemWeb({ tab, pathname, onPress }: Props) {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const selected = useMemo(
        () =>
            pathname.includes(
                `/${TEMPLATE_TO_PATHNAME[tab.name as RootTemplates]}`,
            ),
        [tab.name, pathname],
    );

    const handlePress = useCallback(() => {
        dispatch(
            startSentryTransaction(
                TEMPLATE_TO_SENTRY_RENDERING[tab.name as RootTemplates],
            ),
        );
        dispatch(
            startSentryTransaction(
                TEMPLATE_TO_SENTRY_NAVIGATION[tab.name as RootTemplates],
            ),
        );
        onPress(tab);
    }, [tab, onPress]);

    return (
        <Pressable
            key={tab.POEditorKey}
            style={styles.webMenuItem}
            onPress={handlePress}
            testID={tab.testID}
            accessibilityLabel={
                tab.accessibilityLabel ? t(tab.accessibilityLabel) : ''
            }
            accessibilityRole="button"
        >
            <LocalizedText
                textKey={tab.POEditorKey}
                style={[
                    styles.title,
                    {
                        opacity: selected ? 1 : 0.7,
                    },
                ]}
                numberOfLines={1}
            />
        </Pressable>
    );
}

export default MainMenuItemWeb;
